/** Logotipul. O singură definiție, folosită oriunde apare marca.
 *
 *  Construcția e cea din prototip, literă cu literă: „coresmith" în Jost 700,
 *  „.dev" la 400 în cenușiul stins, și o linie de 2 px în accent numai sub
 *  „core". Rămâne tipografic, nu vectorial, din trei motive: urmărește paleta
 *  prin variabilele CSS, se scalează fără fișier separat, și e exact același
 *  desen — verificat: la 19 px CSS-ul dă 109.92 px, iar conturul vectorial al
 *  aceluiași font 109.16, diferența fiind spațierea pe care CSS o adaugă și
 *  după ultima literă.
 *
 *  Pentru locurile unde fontul nu poate fi garantat — favicon, imagine OG,
 *  atașamente — există varianta vectorială în public/logo.svg, generată din
 *  aceleași contururi Jost.
 */
export default function Wordmark({
  size = 19,
  className,
}: {
  /** înălțimea tipografică în px; linia de accent se scalează cu ea */
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={"wm" + (className ? " " + className : "")}
      style={size === 19 ? undefined : { fontSize: size }}
    >
      <span className="c">core</span>smith<span className="t">.dev</span>
    </span>
  );
}
